/** Marks an accordion section whose fields failed validation. */
export const OFFERING_FORM_ERROR_ATTRIBUTE = "data-offering-form-error";

const FIRST_ERRORED_SECTION_SELECTOR = `[${OFFERING_FORM_ERROR_ATTRIBUTE}="true"]`;

/**
 * Brings the first errored accordion section into view after a failed submit.
 *
 * Pass as react-hook-form's invalid handler: `handleSubmit(onSubmit, scrollToFirstOfferingFormError)`.
 *
 * Without this the coach gets "fill in the required fields above" while every red
 * outline sits off-screen — react-hook-form's own `shouldFocusError` can't help, because
 * the inputs it wants to focus are unmounted inside collapsed sections.
 *
 * Deferred by a frame: react-hook-form invokes this before React has committed the
 * render that marks the sections, so the attribute does not exist yet.
 */
export function scrollToFirstOfferingFormError() {
  const scroll = () => {
    const target = document.querySelector(FIRST_ERRORED_SECTION_SELECTOR);
    // jsdom and older browsers leave scrollIntoView undefined.
    if (target && typeof target.scrollIntoView === "function") {
      target.scrollIntoView({behavior: "smooth", block: "center"});
    }
  };

  if (
    typeof window === "undefined" ||
    typeof window.requestAnimationFrame !== "function"
  ) {
    scroll();
    return;
  }
  window.requestAnimationFrame(scroll);
}
